import React from "react";
import { Phone, Mail, MapPin, MessageCircle, Instagram } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useBooking } from "../components/BookingDialog";
import Reveal from "../components/Reveal";
import { CONTACT } from "../data/mock";

const Contact = () => {
  const { t, lang } = useLang();
  const { openBooking } = useBooking();

  const cards = [
    { icon: Phone, label: t.footer.call, value: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}` },
    { icon: MessageCircle, label: lang === "fr" ? "WhatsApp (support)" : "WhatsApp (support)", value: CONTACT.phone, href: `https://wa.me/${CONTACT.whatsapp}` },
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: t.detail.location, value: CONTACT.city[lang], href: null },
  ];

  return (
    <div className="bg-[#f7f5ef] min-h-screen">
      <section className="pt-40 pb-20">
        <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
          <Reveal>
            <p className="text-[#7c8f74] text-xs tracking-[0.25em] uppercase mb-4">{t.nav.contact}</p>
            <h1 className="font-serif text-5xl md:text-6xl text-[#20261f] mb-5">{t.contactPage.title}</h1>
            <p className="text-[#6b7166] text-lg max-w-xl mx-auto">{t.contactPage.subtitle}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {cards.map((c, i) => {
              const Icon = c.icon;
              const inner = (
                <div className="flex items-center gap-5 bg-white rounded-2xl p-7 border border-[#eceae1] transition-all hover:shadow-[0_18px_40px_-22px_rgba(28,34,30,0.28)] hover:-translate-y-1 h-full">
                  <span className="w-14 h-14 rounded-full bg-[#7c8f74]/12 flex items-center justify-center shrink-0">
                    <Icon size={24} className="text-[#5c6b54]" strokeWidth={1.7} />
                  </span>
                  <div>
                    <p className="text-xs uppercase tracking-[0.15em] text-[#9aa08f] mb-1">{c.label}</p>
                    <p className="text-lg text-[#20261f] font-medium">{c.value}</p>
                  </div>
                </div>
              );
              return (
                <Reveal key={i} delay={i * 80}>
                  {c.href ? (
                    <a href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                      {inner}
                    </a>
                  ) : (
                    <div>{inner}</div>
                  )}
                </Reveal>
              );
            })}
          </div>

          <div className="mt-14 bg-[#1c221e] rounded-3xl p-10 md:p-14 text-center">
            <h2 className="font-serif text-3xl md:text-4xl text-white mb-4">{t.ctaBand.title}</h2>
            <p className="text-white/70 mb-8">{t.ctaBand.text}</p>
            <button
              onClick={() => openBooking()}
              className="inline-flex items-center gap-2 bg-[#7c8f74] hover:bg-[#8ba081] text-white px-10 py-4 rounded-full text-sm tracking-[0.1em] uppercase font-medium transition-all hover:-translate-y-0.5"
            >
              {t.ctaBand.button}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
